import { render, staticRenderFns } from "./VerifyShipper.vue?vue&type=template&id=1baa04da"
import script from "./VerifyShipper.vue?vue&type=script&lang=js"
export * from "./VerifyShipper.vue?vue&type=script&lang=js"
import style0 from "./VerifyShipper.vue?vue&type=style&index=0&id=1baa04da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports